var module = angular.module('octopusApp.projects');

module.directive('volumeBinding', function($uibModal) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl:'areas/projects/actions/docker_run/volume-binding.html',
        scope: {
            action: '=',
            project: '=',
            localNames: '='
        },
        link: function($scope, $element) {
            //$scope.$element = $element;
        },
        controller: function() {
            var vm = this;

            vm.volumeBindings = [];
            vm.formatBinding = formatBinding;
            vm.openEditDialog = openEditDialog;
            vm.removeVolumeBinding = removeVolumeBinding;

            function openEditDialog(existingVolume) {
                $uibModal.open({
                    size: "lg",
                    backdrop: true,
                    keyboard: true,
                    templateUrl: 'areas/projects/actions/docker_run/volume-binding-dialog.html',
                    controller: "VolumeBindingDialogController",
                    resolve: {
                        "projectId" : function() {
                            return vm.project.Id;
                        },
                        "locals": function() {
                            return vm.locals;
                        },
                        "binding": function() {
                            if (existingVolume) {
                                return {
                                    container: existingVolume.container,
                                    host: existingVolume.host,
                                    readOnly: existingVolume.readOnly,
                                    noCopy: existingVolume.noCopy
                                };
                            } else {
                                return {
                                    container: '',
                                    host: '',
                                    readOnly: 'False',
                                    noCopy: 'False'
                                };
                            }
                        },
                        "existing": function() {
                            return null;
                        }
                    }
                }).result.then(function(result) {
                    if (!result) {
                        return;
                    }

                    if (existingVolume) {
                        removeVolumeBinding(existingVolume);
                    }

                    vm.volumeBindings.push(result);
                    setProperties();
                });
            }

            function removeVolumeBinding(binding) {
                var idx = vm.volumeBindings.indexOf(binding);
                if (idx >= 0) {
                    vm.volumeBindings.splice(idx, 1);
                }
                setProperties();
            }

            function setProperties() {
                vm.action.Properties["Octopus.Action.Docker.VolumeBindings"] =  JSON.stringify(vm.volumeBindings.reduce(function(obj, binding) {
                    obj[binding.container] = {
                        host: binding.host,
                        readOnly: isTrue(binding.readOnly, 'readonly'),
                        noCopy: isTrue(binding.noCopy, 'nocopy')
                    };
                    return obj;
                }, {}));
            }

            function loadVolumeBindings() {
                var json = vm.action.Properties["Octopus.Action.Docker.VolumeBindings"];
                if (!!json) {
                    try {
                        var obj = JSON.parse(json);
                        vm.volumeBindings = _.map(obj, function (binding, container) {
                            return {
                                container: container,
                                host: binding.host,
                                readOnly: isTrue(binding.readOnly, 'readonly'),
                                noCopy: isTrue(binding.noCopy, 'nocopy')
                            };
                        });

                    } catch (err) {
                        console.error(err);
                    }
                }
            }
            

            function isTrue(noCopy, trueString) {
                return (!!noCopy && (noCopy === true || noCopy.toLowerCase() === "true" || noCopy.toLowerCase()  === trueString));
            }

            function formatBinding(binding) {
                var format = binding.container;
                if (binding.host) {
                    format = "<b>Host: </b>"+ binding.host + " : <b>Container: </b>" + binding.container;
                }
                if (isTrue(binding.readOnly, 'readonly')) {
                    format += " <b>readonly</b>";
                }

                if (isTrue(binding.noCopy, 'nocopy')) {
                    format += " <b>nocopy</b>";
                }
                return format;
            }

            function init() {
                loadVolumeBindings();
            }
            init();
        },
        controllerAs: 'vm',
        bindToController: true
    };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/docker_run/volume-binding.js
// module id = 1741360816175924
// module chunks = 1